import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { HorizontalLine } from './HorizontalLine';

class StatsPage extends React.Component {
    state = {
        website: null,
        loading: true,
        timeRange: '7days',
        summaryStats: {
            blockedSessions: 0,
            savedBudget: 0,
            blockedIPs: 0,
            suspiciousSessions: 0,
            lastUpdate: new Date().toLocaleDateString('ru-RU')
        },
        detailedStats: {
            totalSessions: 0,
            botSessionsByDevice: {},
            botSources: {},
            sessions: [],
            mockSessions: [
                {
                    id: 1,
                    date: '16.01.2026',
                    time: '02:18',
                    ip: '188.17.212.119',
                    location: 'Челябинск, Россия',
                    sessionTime: 5,
                    source: 'поиск',
                    reason: 'Высокий коэффициент подозрительности',
                    device: 'Desktop',
                    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
                    actions: 3,
                    pages: 2,
                    countryCode: 'RU'
                },
                {
                    id: 2,
                    date: '16.01.2026',
                    time: '02:10',
                    ip: '185.119.2.178',
                    location: 'Ленинградская обл., Россия',
                    sessionTime: 6,
                    source: 'поиск',
                    reason: 'Высокий коэффициент подозрительности',
                    device: 'Mobile',
                    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X)',
                    actions: 2,
                    pages: 1,
                    countryCode: 'RU'
                },
                {
                    id: 3,
                    date: '15.01.2026',
                    time: '23:45',
                    ip: '91.206.15.12',
                    location: 'Москва, Россия',
                    sessionTime: 3,
                    source: 'прямой',
                    reason: 'Поведенческие паттерны бота',
                    device: 'Desktop',
                    userAgent: 'Mozilla/5.0 (Windows NT 6.1; Win64; x64; rv:47.0)',
                    actions: 1,
                    pages: 1,
                    countryCode: 'RU'
                }
            ],
            totalPages: 0,
            statistics: {
                total_suspicious: 0,
                unique_ips: 0,
                blocked_last_24h: 0
            }
        },
        showDetailed: false,
        selectedSession: null,
        currentPage: 1,
        itemsPerPage: 5,
        error: null
    }

    componentDidMount() {
        this.loadWebsiteData(this.props.websiteId);
        this.loadStatsData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.websiteId !== this.props.websiteId) {
            this.loadWebsiteData(this.props.websiteId);
            this.loadStatsData();
        }
    }

    // Получение токена из куки
    getAuthToken = () => {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'clickanti_token') {
                return value;
            }
        }
        return null;
    }

    // Загрузка данных о сайте
    loadWebsiteData = (websiteId) => {
        this.setState({
            website: {
                id: websiteId,
                url: 'Загрузка...',
                is_active: true
            }
        });
    }

    // Загрузка общей и подробной статистики
    loadStatsData = async () => {
        const websiteId = this.props.websiteId;
        const token = this.getAuthToken();

        if (!token) {
            this.setState({
                error: 'Не найден токен авторизации',
                loading: false
            });
            return;
        }

        try {
            this.setState({ loading: true, error: null });

            // Параллельно загружаем общую и подробную статистику
            const [summaryResponse, detailedResponse] = await Promise.all([
                fetch(`https://api.clickanti.ru/api/clickanti/sessions/stats?website_id=${websiteId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }),
                fetch(`https://api.clickanti.ru/api/clickanti/websites/${websiteId}/sessions/suspicious?page=${this.state.currentPage}&page_size=${this.state.itemsPerPage}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })
            ]);

            if (!summaryResponse.ok || !detailedResponse.ok) {
                throw new Error('Ошибка при загрузке данных');
            }

            const summaryData = await summaryResponse.json();
            const detailedData = await detailedResponse.json();

            // Обновляем данные о сайте
            if (detailedData.website_info) {
                this.setState({
                    website: detailedData.website_info
                });
            }

            // Рассчитываем сэкономленный бюджет (примерная формула: заблокированные сессии * средняя стоимость клика)
            const avgClickCost = 120; // средняя стоимость клика в рублях
            const savedBudget = summaryData.blocked_sessions * avgClickCost;

            // Обновляем общую статистику
            this.setState({
                summaryStats: {
                    blockedSessions: summaryData.blocked_sessions || 0,
                    savedBudget: Math.round(savedBudget),
                    blockedIPs: summaryData.blocked_ips || 0,
                    suspiciousSessions: detailedData.statistics?.total_suspicious || 0,
                    lastUpdate: new Date().toLocaleDateString('ru-RU')
                },
                detailedStats: {
                    totalSessions: summaryData.total_sessions || 0,
                    botSessionsByDevice: summaryData.devices || [],
                    botSources: summaryData.traffic_sources || [],
                    sessions: this.mapSessionsData(detailedData.results || []),
                    mockSessions: this.state.detailedStats.mockSessions,
                    totalPages: Math.ceil((detailedData.count || 0) / this.state.itemsPerPage),
                    statistics: detailedData.statistics || {}
                },
                loading: false
            });

        } catch (error) {
            console.error('Ошибка загрузки статистики:', error);
            this.setState({
                error: 'Не удалось загрузить данные. Попробуйте позже.',
                loading: false
            });
        }
    }

    // Маппинг данных сессий из API в формат компонента
    mapSessionsData = (apiSessions) => {
        return apiSessions.map(session => {
            const createdAt = new Date(session.created_at);
            
            return {
                id: session.id,
                date: createdAt.toLocaleDateString('ru-RU'),
                time: createdAt.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                ip: session.ip_address,
                location: `${session.location_city || ''}, ${session.location_country || ''}`.replace(/^,\s*/, ''),
                sessionTime: session.duration_seconds,
                source: session.traffic_source_display || session.traffic_source,
                reason: session.block_reason || `Высокий коэффициент подозрительности `,
                device: this.mapDeviceType(session.device_type),
                userAgent: session.user_agent || 'Неизвестно',
                actions: 0, // API не предоставляет эти данные
                pages: 0, // API не предоставляет эти данные
                countryCode: this.getCountryCode(session.location_country),
                browser: session.browser,
                os: session.os,
                screenResolution: session.screen_resolution,
                referrer: session.referrer,
                suspicionScore: session.suspicion_score,
                isBlocked: session.is_blocked
            };
        });
    }

    // Маппинг типа устройства
    mapDeviceType = (deviceType) => {
        const deviceMap = {
            'desktop': 'Desktop',
            'mobile': 'Mobile',
            'tablet': 'Tablet'
        };
        return deviceMap[deviceType?.toLowerCase()] || 'Desktop';
    }

    // Определение кода страны
    getCountryCode = (country) => {
        if (!country) return 'UN';
        
        const countryMap = {
            'Россия': 'RU',
            'Russia': 'RU',
            'Украина': 'UA',
            'Ukraine': 'UA',
            'Беларусь': 'BY',
            'Belarus': 'BY'
        };
        
        return countryMap[country] || 'UN';
    }

    // Загрузка данных при изменении страницы
    handlePageChange = async (pageNumber) => {
        await this.setState({ currentPage: pageNumber });
        await this.loadStatsData();
    }

    // Обработка изменения количества элементов на странице
    handleItemsPerPageChange = async (newItemsPerPage) => {
        await this.setState({ 
            itemsPerPage: newItemsPerPage, 
            currentPage: 1 
        });
        await this.loadStatsData();
    }

    formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    goBack = () => {
        window.history.back();
    }

    toggleDetailedView = () => {
        this.setState(prevState => ({
            showDetailed: !prevState.showDetailed
        }));
    }

    handleSessionClick = (session) => {
        this.setState({ selectedSession: session });
    }

    closeSessionDetails = () => {
        this.setState({ selectedSession: null });
    }

    getStatusColor = (sessionTime) => {
        if (sessionTime < 3) return '#ff3333';
        if (sessionTime < 6) return '#ff9900';
        return '#9197B3';
    }

    getSourceColor = (source) => {
        switch(source) {
            case 'поиск': return '#0767F4';
            case 'прямой': return '#39b339';
            case 'соцсети': return '#9C27B0';
            case 'реферал': return '#ff9900';
            default: return '#9197B3';
        }
    }

    getDeviceIcon = (device) => {
        switch(device) {
            case 'Desktop': return '💻';
            case 'Mobile': return '📱';
            case 'Tablet': return '📱';
            default: return '🖥️';
        }
    }

    render() {
        const { website, loading, summaryStats, detailedStats, showDetailed, selectedSession, currentPage, itemsPerPage, error } = this.state;

        if (loading) {
            return (
                <div className='createPage' style={{textAlign: 'center', padding: '4em'}}>
                    <div className='notCreatedText'>Загрузка статистики...</div>
                </div>
            );
        }

        if (error) {
            return (
                <div className='createPage'>
                    <h1>Ошибка</h1>
                    <HorizontalLine />
                    <div style={{textAlign: 'center', padding: '3em'}}>
                        <p className='notCreatedText' style={{color: '#ff3333'}}>{error}</p>
                        <button onClick={this.goBack} className='bigButton' style={{marginTop: '2em'}}>
                            Вернуться к списку сайтов
                        </button>
                    </div>
                </div>
            );
        }

        if (!website) {
            return (
                <div className='createPage'>
                    <h1>Сайт не найден</h1>
                    <HorizontalLine />
                    <div style={{textAlign: 'center', padding: '3em'}}>
                        <p className='notCreatedText'>Запрашиваемый сайт не существует или был удален.</p>
                        <button onClick={this.goBack} className='bigButton' style={{marginTop: '2em'}}>
                            Вернуться к списку сайтов
                        </button>
                    </div>
                </div>
            );
        }

        // Используем данные из API или заглушку для отображения
        const currentSessions = detailedStats.sessions.length > 0 
            ? detailedStats.sessions 
            : detailedStats.mockSessions.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
        
        const totalPages = detailedStats.totalPages > 0 
            ? detailedStats.totalPages 
            : Math.ceil(detailedStats.mockSessions.length / itemsPerPage);

        return (
            <div className='createPage'>
                {/* Кнопка назад */}
                <div className='createWidgetMainBlock_back' onClick={this.goBack} style={{cursor: 'pointer', marginBottom: '2em'}}>
                    ← Назад к списку сайтов
                </div>

                <h1>Статистика защиты для {website.url}</h1>
                <HorizontalLine />
                
                {/* Переключение между общей и подробной статистикой */}
                <div style={{
                    display: 'flex',
                    gap: '1em',
                    marginTop: '2em',
                    marginBottom: showDetailed ? '0' : '2em'
                }}>
                    <button 
                        onClick={() => this.setState({ showDetailed: false })}
                        style={{
                            padding: '0.8em 1.8em',
                            border: 'none',
                            borderRadius: '0.4em',
                            background: !showDetailed ? '#0767F4' : '#F3F3F3',
                            color: !showDetailed ? 'white' : '#666',
                            cursor: 'pointer',
                            fontSize: '1em',
                            fontWeight: '500',
                            transition: 'all 0.3s'
                        }}
                    >
                        Общая статистика
                    </button>
                    <button 
                        onClick={() => this.setState({ showDetailed: true })}
                        style={{
                            padding: '0.8em 1.8em',
                            border: 'none',
                            borderRadius: '0.4em',
                            background: showDetailed ? '#0767F4' : '#F3F3F3',
                            color: showDetailed ? 'white' : '#666',
                            cursor: 'pointer',
                            fontSize: '1em',
                            fontWeight: '500',
                            transition: 'all 0.3s'
                        }}
                    >
                        Подробный отчет
                    </button>
                </div>

                {!showDetailed ? (
                    /* ОБЩАЯ СТАТИСТИКА */
                    <div className='editBlock' style={{marginTop: '2em'}}>
                        <div className='editBlock_name'>
                            <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                                Защита от ботов и мошенничества
                            </h2>
                            <div style={{
                                display: 'inline-block',
                                marginLeft: '2em',
                                color: '#9197B3',
                                fontSize: '0.9em'
                            }}>
                                Обновлено: {summaryStats.lastUpdate}
                            </div>
                        </div>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '1.5em',
                            marginTop: '1.5em'
                        }}>
                            {/* Заблокированных сессий */}
                            <div style={{
                                background: '#FAFBFF',
                                borderRadius: '0.8em',
                                padding: '1.5em',
                                borderLeft: '4px solid #0767F4'
                            }}>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3',
                                    marginBottom: '0.5em'
                                }}>
                                    Заблокированных сессий
                                </div>
                                <div style={{
                                    fontSize: '2em',
                                    fontWeight: '700',
                                    color: '#0767F4',
                                    marginBottom: '0.3em'
                                }}>
                                    {summaryStats.blockedSessions}
                                </div>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3'
                                }}>
                                    {summaryStats.lastUpdate}
                                </div>
                            </div>
                            
                            {/* Экономия бюджета */}
                            <div style={{
                                background: '#FAFBFF',
                                borderRadius: '0.8em',
                                padding: '1.5em',
                                borderLeft: '4px solid #39b339'
                            }}>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3',
                                    marginBottom: '0.5em'
                                }}>
                                    Экономия бюджета
                                </div>
                                <div style={{
                                    fontSize: '2em',
                                    fontWeight: '700',
                                    color: '#39b339',
                                    marginBottom: '0.3em'
                                }}>
                                    {summaryStats.savedBudget}₽
                                </div>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3'
                                }}>
                                    {summaryStats.lastUpdate}
                                </div>
                            </div>
                            
                            {/* Заблокированные IP-адреса */}
                            <div style={{
                                background: '#FAFBFF',
                                borderRadius: '0.8em',
                                padding: '1.5em',
                                borderLeft: '4px solid #ff3333'
                            }}>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3',
                                    marginBottom: '0.5em'
                                }}>
                                    Заблокированные IP-адреса
                                </div>
                                <div style={{
                                    fontSize: '2em',
                                    fontWeight: '700',
                                    color: '#ff3333',
                                    marginBottom: '0.3em'
                                }}>
                                    {summaryStats.blockedIPs}
                                </div>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3'
                                }}>
                                    {summaryStats.lastUpdate}
                                </div>
                            </div>
                            
                            {/* Подозрительные сессии */}
                            <div style={{
                                background: '#FAFBFF',
                                borderRadius: '0.8em',
                                padding: '1.5em',
                                borderLeft: '4px solid #ff9900'
                            }}>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3',
                                    marginBottom: '0.5em'
                                }}>
                                    Подозрительные сессии
                                </div>
                                <div style={{
                                    fontSize: '2em',
                                    fontWeight: '700',
                                    color: '#ff9900',
                                    marginBottom: '0.3em'
                                }}>
                                    {summaryStats.suspiciousSessions}
                                </div>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#9197B3'
                                }}>
                                    за 7 дней
                                </div>
                            </div>
                        </div>
                        
                        {/* Кнопка для перехода к подробной статистике */}
                        <div style={{textAlign: 'right', marginTop: '2em'}}>
                            <button 
                                onClick={this.toggleDetailedView}
                                className='btn1'
                                style={{
                                    padding: '0.8em 2em',
                                    fontSize: '1em'
                                }}
                            >
                                Показать подробный отчет →
                            </button>
                        </div>
                    </div>
                ) : (
                    /* ПОДРОБНЫЙ ОТЧЕТ */
                    <div>
                        {/* Информационный блок */}
                        <div className='editBlock' style={{marginTop: '2em'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start'
                            }}>
                                <div>
                                    <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600', marginBottom: '0.5em'}}>
                                        Подробный отчет о блокировках
                                    </h2>
                                    <p style={{color: '#666', lineHeight: '1.6'}}>
                                        Сессии, которые мы пометили как "подозрительные", мы автоматически (раз в 10 минут) 
                                        передаем по API в системы Яндекс (и/или Google), отмечая их соответствующим параметром.
                                    </p>
                                </div>
                                <div style={{color: '#9197B3', fontSize: '0.9em'}}>
                                    17.12.2025 - {summaryStats.lastUpdate}
                                </div>
                            </div>
                        </div>

                        {/* Упрощенная таблица сессий */}
                        <div className='editBlock' style={{marginTop: '2em'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '1.5em'
                            }}>
                                <h2 style={{color: '#252733', fontSize: '1.3em', fontWeight: '600'}}>
                                    Заблокированные сессии
                                </h2>
                                <div style={{color: '#9197B3', fontSize: '0.9em'}}>
                                    Показано: {currentSessions.length} из {detailedStats.statistics.total_suspicious || detailedStats.mockSessions.length}
                                </div>
                            </div>
                            
                            {/* Таблица */}
                            <div style={{
                                overflowX: 'auto',
                                borderRadius: '0.5em',
                                border: '1px solid #E2ECF9'
                            }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    fontSize: '0.95em'
                                }}>
                                    <thead>
                                        <tr style={{
                                            background: '#F3F3F3',
                                            color: '#9197B3',
                                            fontWeight: '600',
                                            fontSize: '0.9em'
                                        }}>
                                            <th style={{padding: '1em', textAlign: 'left', width: '15%'}}>Дата</th>
                                            <th style={{padding: '1em', textAlign: 'left', width: '15%'}}>IP адрес</th>
                                            <th style={{padding: '1em', textAlign: 'left', width: '20%'}}>Локация</th>
                                            <th style={{padding: '1em', textAlign: 'left', width: '10%'}}>Время</th>
                                            <th style={{padding: '1em', textAlign: 'left', width: '15%'}}>Источник</th>
                                            <th style={{padding: '1em', textAlign: 'left', width: '25%'}}>Причина блокировки</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentSessions.map(session => (
                                            <tr 
                                                key={session.id}
                                                onClick={() => this.handleSessionClick(session)}
                                                style={{
                                                    borderBottom: '1px solid #F3F3F3',
                                                    cursor: 'pointer',
                                                    transition: 'background 0.2s'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.background = '#FAFBFF'}
                                                onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                            >
                                                {/* Дата и время */}
                                                <td style={{padding: '1em'}}>
                                                    <div style={{color: '#252733', fontWeight: '500'}}>
                                                        {session.date}
                                                    </div>
                                                    <div style={{color: '#9197B3', fontSize: '0.85em', marginTop: '0.2em'}}>
                                                        {session.time}
                                                    </div>
                                                </td>
                                                
                                                {/* IP адрес */}
                                                <td style={{padding: '1em'}}>
                                                    <div style={{color: '#0767F4', fontWeight: '500', fontFamily: 'monospace'}}>
                                                        {session.ip}
                                                    </div>
                                                    <div style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '0.3em',
                                                        marginTop: '0.3em',
                                                        fontSize: '0.8em',
                                                        color: '#9197B3'
                                                    }}>
                                                        {this.getDeviceIcon(session.device)} {session.device}
                                                    </div>
                                                </td>
                                                
                                                {/* Локация */}
                                                <td style={{padding: '1em', color: '#666'}}>
                                                    {session.location}
                                                </td>
                                                
                                                {/* Время сессии */}
                                                <td style={{padding: '1em'}}>
                                                    <div style={{
                                                        color: this.getStatusColor(session.sessionTime),
                                                        fontWeight: '600',
                                                        textAlign: 'center',
                                                        padding: '0.3em 0.6em',
                                                        background: this.getStatusColor(session.sessionTime) + '15',
                                                        borderRadius: '0.3em',
                                                        display: 'inline-block'
                                                    }}>
                                                        {session.sessionTime} сек
                                                    </div>
                                                </td>
                                                
                                                {/* Источник */}
                                                <td style={{padding: '1em'}}>
                                                    <div style={{
                                                        color: this.getSourceColor(session.source),
                                                        fontWeight: '500',
                                                        textAlign: 'center',
                                                        padding: '0.3em 0.8em',
                                                        background: this.getSourceColor(session.source) + '15',
                                                        borderRadius: '1em',
                                                        display: 'inline-block',
                                                        fontSize: '0.85em'
                                                    }}>
                                                        {session.source}
                                                    </div>
                                                </td>
                                                
                                                {/* Причина */}
                                                <td style={{padding: '1em'}}>
                                                    <div style={{
                                                        color: '#ff3333',
                                                        fontSize: '0.9em',
                                                        lineHeight: '1.4'
                                                    }}>
                                                        {session.reason}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            {/* ПАГИНАЦИЯ */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '2em',
                                padding: '1em',
                                background: '#f8fafc',
                                borderRadius: '0.5em'
                            }}>
                                <div style={{color: '#64748b', fontSize: '0.9em'}}>
                                    Страница <strong>{currentPage}</strong> из <strong>{totalPages}</strong>
                                </div>
                                
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5em'
                                }}>
                                    {/* Кнопка "Назад" */}
                                    <button 
                                        onClick={() => this.handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        style={{
                                            padding: '0.5em 1em',
                                            border: '1px solid #cbd5e1',
                                            background: currentPage === 1 ? '#f1f5f9' : 'white',
                                            color: currentPage === 1 ? '#94a3b8' : '#475569',
                                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                            borderRadius: '0.375em',
                                            fontSize: '0.9em',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.3em',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (currentPage !== 1) {
                                                e.currentTarget.style.background = '#f1f5f9';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (currentPage !== 1) {
                                                e.currentTarget.style.background = 'white';
                                            }
                                        }}
                                    >
                                        <span>←</span>
                                        <span>Назад</span>
                                    </button>
                                    
                                    {/* Номера страниц */}
                                    <div style={{
                                        display: 'flex',
                                        gap: '0.25em'
                                    }}>
                                        {(() => {
                                            const pages = [];
                                            
                                            // Всегда показываем первую страницу
                                            if (currentPage > 2) {
                                                pages.push(
                                                    <button 
                                                        key={1}
                                                        onClick={() => this.handlePageChange(1)}
                                                        style={{
                                                            padding: '0.5em 0.8em',
                                                            minWidth: '2.2em',
                                                            border: '1px solid #cbd5e1',
                                                            background: 'white',
                                                            color: '#475569',
                                                            cursor: 'pointer',
                                                            borderRadius: '0.375em',
                                                            fontSize: '0.9em',
                                                            fontWeight: '400',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                                    >
                                                        1
                                                    </button>
                                                );
                                            }
                                            
                                            // Многоточие, если нужно
                                            if (currentPage > 3) {
                                                pages.push(
                                                    <span key="dots1" style={{
                                                        padding: '0.5em 0.3em',
                                                        color: '#94a3b8',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        ...
                                                    </span>
                                                );
                                            }
                                            
                                            // Текущая страница и соседние
                                            for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages, currentPage + 1); i++) {
                                                if (i === 1 && currentPage > 2) continue;
                                                pages.push(
                                                    <button 
                                                        key={i}
                                                        onClick={() => this.handlePageChange(i)}
                                                        style={{
                                                            padding: '0.5em 0.8em',
                                                            minWidth: '2.2em',
                                                            border: '1px solid',
                                                            background: currentPage === i ? '#0767F4' : 'white',
                                                            borderColor: currentPage === i ? '#0767F4' : '#cbd5e1',
                                                            color: currentPage === i ? 'white' : '#475569',
                                                            cursor: 'pointer',
                                                            borderRadius: '0.375em',
                                                            fontSize: '0.9em',
                                                            fontWeight: currentPage === i ? '600' : '400',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (currentPage !== i) {
                                                                e.currentTarget.style.background = '#f1f5f9';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (currentPage !== i) {
                                                                e.currentTarget.style.background = 'white';
                                                            }
                                                        }}
                                                    >
                                                        {i}
                                                    </button>
                                                );
                                            }
                                            
                                            // Многоточие, если нужно
                                            if (currentPage < totalPages - 2) {
                                                pages.push(
                                                    <span key="dots2" style={{
                                                        padding: '0.5em 0.3em',
                                                        color: '#94a3b8',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        ...
                                                    </span>
                                                );
                                            }
                                            
                                            // Всегда показываем последнюю страницу
                                            if (currentPage < totalPages - 1) {
                                                pages.push(
                                                    <button 
                                                        key={totalPages}
                                                        onClick={() => this.handlePageChange(totalPages)}
                                                        style={{
                                                            padding: '0.5em 0.8em',
                                                            minWidth: '2.2em',
                                                            border: '1px solid #cbd5e1',
                                                            background: 'white',
                                                            color: '#475569',
                                                            cursor: 'pointer',
                                                            borderRadius: '0.375em',
                                                            fontSize: '0.9em',
                                                            fontWeight: '400',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                );
                                            }
                                            
                                            return pages;
                                        })()}
                                    </div>
                                    
                                    {/* Кнопка "Вперед" */}
                                    <button 
                                        onClick={() => this.handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        style={{
                                            padding: '0.5em 1em',
                                            border: '1px solid #cbd5e1',
                                            background: currentPage === totalPages ? '#f1f5f9' : 'white',
                                            color: currentPage === totalPages ? '#94a3b8' : '#475569',
                                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                            borderRadius: '0.375em',
                                            fontSize: '0.9em',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.3em',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (currentPage !== totalPages) {
                                                e.currentTarget.style.background = '#f1f5f9';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (currentPage !== totalPages) {
                                                e.currentTarget.style.background = 'white';
                                            }
                                        }}
                                    >
                                        <span>Вперед</span>
                                        <span>→</span>
                                    </button>
                                </div>
                                
                                <div style={{color: '#64748b', fontSize: '0.9em'}}>
                                    Записей на странице: 
                                    <select 
                                        value={itemsPerPage}
                                        onChange={(e) => this.handleItemsPerPageChange(parseInt(e.target.value))}
                                        style={{
                                            marginLeft: '0.5em',
                                            padding: '0.3em 0.5em',
                                            border: '1px solid #cbd5e1',
                                            borderRadius: '0.375em',
                                            background: 'white',
                                            color: '#475569',
                                            fontSize: '0.9em'
                                        }}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Модальное окно с деталями сессии */}
                {selectedSession && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '2em'
                    }} onClick={this.closeSessionDetails}>
                        <div style={{
                            background: 'white',
                            borderRadius: '1em',
                            padding: '2.5em',
                            maxWidth: '600px',
                            width: '100%',
                            position: 'relative',
                            maxHeight: '80vh',
                            overflowY: 'auto'
                        }} onClick={(e) => e.stopPropagation()}>
                            <button 
                                onClick={this.closeSessionDetails}
                                style={{
                                    position: 'absolute',
                                    top: '1em',
                                    right: '1em',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '1.5em',
                                    color: '#9197B3',
                                    cursor: 'pointer'
                                }}
                            >
                                ×
                            </button>
                            
                            <h3 style={{
                                fontSize: '1.6em',
                                fontWeight: '600',
                                color: '#252733',
                                marginBottom: '1.5em',
                                paddingRight: '2em'
                            }}>
                                Подробности сессии #{selectedSession.id}
                            </h3>
                            
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: '1.5em',
                                marginBottom: '1.5em'
                            }}>
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Дата и время</div>
                                    <div style={{color: '#252733', fontWeight: '600'}}>
                                        {selectedSession.date} {selectedSession.time}
                                    </div>
                                </div>
                                
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>IP адрес</div>
                                    <div style={{color: '#0767F4', fontWeight: '600', fontFamily: 'monospace'}}>
                                        {selectedSession.ip}
                                    </div>
                                </div>
                                
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Локация</div>
                                    <div style={{color: '#252733'}}>{selectedSession.location}</div>
                                </div>
                                
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Устройство</div>
                                    <div style={{color: '#252733', fontWeight: '600'}}>
                                        {this.getDeviceIcon(selectedSession.device)} {selectedSession.device}
                                    </div>
                                </div>
                                
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Источник трафика</div>
                                    <div style={{
                                        color: this.getSourceColor(selectedSession.source),
                                        fontWeight: '500',
                                        padding: '0.3em 0.8em',
                                        background: this.getSourceColor(selectedSession.source) + '15',
                                        borderRadius: '1em',
                                        display: 'inline-block',
                                        fontSize: '0.9em'
                                    }}>
                                        {selectedSession.source}
                                    </div>
                                </div>
                                
                                <div>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Длительность сессии</div>
                                    <div style={{
                                        color: this.getStatusColor(selectedSession.sessionTime),
                                        fontWeight: '600',
                                        padding: '0.3em 0.8em',
                                        background: this.getStatusColor(selectedSession.sessionTime) + '15',
                                        borderRadius: '0.3em',
                                        display: 'inline-block'
                                    }}>
                                        {selectedSession.sessionTime} секунд
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{marginBottom: '1.5em'}}>
                                <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Причина блокировки</div>
                                <div style={{
                                    color: '#ff3333',
                                    fontWeight: '600',
                                    padding: '0.8em',
                                    background: '#ff333310',
                                    borderRadius: '0.5em',
                                    borderLeft: '4px solid #ff3333'
                                }}>
                                    Подозрительная сессия
                                </div>
                            </div>
                            
                            <div style={{marginBottom: '1.5em'}}>
                                <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>User-Agent</div>
                                <div style={{
                                    color: '#666',
                                    fontFamily: 'monospace',
                                    fontSize: '0.9em',
                                    padding: '0.8em',
                                    background: '#f5f5f5',
                                    borderRadius: '0.5em',
                                    wordBreak: 'break-all'
                                }}>
                                    {selectedSession.userAgent}
                                </div>
                            </div>
                            
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '1em',
                                marginTop: '1.5em',
                                paddingTop: '1.5em',
                                borderTop: '1px solid #E2ECF9'
                            }}>
                                <div style={{textAlign: 'center'}}>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Действия</div>
                                    <div style={{color: '#252733', fontWeight: '600', fontSize: '1.2em'}}>
                                        {selectedSession.actions}
                                    </div>
                                </div>
                                
                                <div style={{textAlign: 'center'}}>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Просмотры</div>
                                    <div style={{color: '#252733', fontWeight: '600', fontSize: '1.2em'}}>
                                        {selectedSession.pages}
                                    </div>
                                </div>
                                
                                <div style={{textAlign: 'center'}}>
                                    <div style={{color: '#9197B3', fontSize: '0.9em', marginBottom: '0.3em'}}>Страна</div>
                                    <div style={{
                                        color: '#252733',
                                        fontWeight: '600',
                                        fontSize: '1.2em',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '0.3em'
                                    }}>
                                        {selectedSession.countryCode === 'RU' ? '🇷🇺' : 
                                         selectedSession.countryCode === 'UA' ? '🇺🇦' : 
                                         selectedSession.countryCode === 'BY' ? '🇧🇾' : '🌍'}
                                        {selectedSession.countryCode}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

// Обертка для использования useParams
const StatsPageWrapper = () => {
    let { id } = useParams();
    return <StatsPage websiteId={id} />;
};

export default StatsPageWrapper;